import { render, staticRenderFns } from "./Ktp.vue?vue&type=template&id=8159f908&"
import script from "./Ktp.vue?vue&type=script&lang=js&"
export * from "./Ktp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports